(() => {
  const config = window.Ayisigi || {};
  let lastFocused = null;
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const strings = config.strings || {};
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char]);
  const formatMoney = (cents, currency = window.Shopify?.currency?.active || 'TRY') => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency }).format(cents / 100);
  const announce = (message) => { const live = document.querySelector('[data-cart-live]'); if (live) live.textContent = message; };
  const toast = (message) => { const node = document.querySelector('[data-toast]'); if (!node) return; node.textContent = message; node.classList.add('is-visible'); window.clearTimeout(node.toastTimer); node.toastTimer = window.setTimeout(() => node.classList.remove('is-visible'), 2200); };

  function openDrawer(trigger) {
    const node = drawer(); if (!node) return;
    lastFocused = trigger || document.activeElement;
    document.body.classList.add('drawer-open');
    node.inert = false;
    node.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    const main = document.querySelector('#MainContent'); const header = document.querySelector('[data-header]');
    if (main) main.inert = true; if (header) header.inert = true;
    node.querySelector('[data-cart-close]')?.focus();
  }

  function closeDrawer() {
    const node = drawer(); if (!node) return;
    if (!document.body.classList.contains('drawer-open')) return;
    document.body.classList.remove('drawer-open');
    node.inert = true;
    node.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    const main = document.querySelector('#MainContent'); const header = document.querySelector('[data-header]');
    if (main) main.inert = false; if (header) header.inert = false;
    lastFocused?.focus();
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !document.body.classList.contains('drawer-open')) return;
    const node = drawer();
    const focusable = [...node.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, select')].filter((el) => !el.hidden && el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0]; const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const node = drawer(); if (!node) return;
    const empty = node.querySelector('[data-cart-empty]'); const items = node.querySelector('[data-cart-items]'); const footer = node.querySelector('[data-cart-footer]');
    empty.hidden = cart.item_count > 0; footer.hidden = cart.item_count === 0;
    items.innerHTML = cart.items.map((item, index) => `<div class="ay-cart-item" data-cart-line data-key="${escapeHtml(item.key)}">
      ${item.image ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}&width=180" width="90" height="110" alt="${escapeHtml(item.product_title)}"></a>` : ''}
      <div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>${item.variant_title ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}<span>${formatMoney(item.final_line_price, cart.currency)} </span><label class="visually-hidden" for="DrawerQty-${index}">${escapeHtml(strings.quantity || 'Adet')}</label><input id="DrawerQty-${index}" type="number" min="0" value="${item.quantity}" data-cart-quantity></div>
      <button type="button" data-cart-remove aria-label="${escapeHtml(strings.remove || 'Kaldır')}: ${escapeHtml(item.product_title)}">×</button></div>`).join('');
    const total = node.querySelector('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price, cart.currency);
  }

  async function getCart() {
    const response = await fetch(`${config.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(strings.cartError || 'Sepet güncellenemedi.');
    return response.json();
  }

  async function changeCart(key, quantity) {
    const response = await fetch(`${config.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || strings.cartError || 'Sepet güncellenemedi.');
    renderCart(data); announce(strings.cartUpdated || 'Sepet güncellendi.');
  }

  async function addToCart(form, submitter) {
    const status = form.querySelector('[data-product-status]'); const button = submitter || form.querySelector('[type="submit"]');
    if (button) button.disabled = true; if (status) status.textContent = '';
    try {
      const response = await fetch(`${config.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.cartError || 'Ürün sepete eklenemedi.');
      openDrawer(button); toast(strings.added || 'Ürün sepete eklendi.'); announce(strings.added || 'Ürün sepete eklendi.');
      try { const cart = await getCart(); renderCart(cart); } catch (refreshError) { window.location.assign(config.routes.cart); }
    } catch (error) {
      if (status) status.textContent = error.message;
      const errorBox = drawer()?.querySelector('[data-cart-error]'); if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; }
    } finally { if (button) { const variant = form.querySelector('[data-variant-select]')?.selectedOptions[0]; button.disabled = variant ? variant.dataset.available !== 'true' : false; } }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]'); if (!form) return;
    event.preventDefault(); addToCart(form, event.submitter);
  });
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]'); if (open) { event.preventDefault(); openDrawer(open); return; }
    if (event.target.closest('[data-cart-close]') || event.target.matches('[data-cart-overlay]')) { closeDrawer(); return; }
    const remove = event.target.closest('[data-cart-remove]'); if (remove) { const line = remove.closest('[data-cart-line]'); changeCart(line.dataset.key, 0).catch((error) => announce(error.message)); return; }
    const menuButton = event.target.closest('[data-menu-toggle]'); if (menuButton) { const menu = document.querySelector('[data-mobile-menu]'); const opening = menu.hidden; menu.hidden = !opening; menuButton.setAttribute('aria-expanded', String(opening)); }
  });
  document.addEventListener('change', (event) => {
    const quantity = event.target.closest('[data-cart-quantity]'); if (quantity) { const line = quantity.closest('[data-cart-line]'); changeCart(line.dataset.key, Math.max(0, Number(quantity.value) || 0)).catch((error) => announce(error.message)); }
    const localization = event.target.closest('[data-localization-select]'); if (localization) { localization.form.submit(); return; }
    const select = event.target.closest('[data-variant-select]'); if (select) {
      const option = select.selectedOptions[0]; const form = select.closest('[data-product-form]'); const priceNode = form.closest('[data-product-section]')?.querySelector('[data-product-price]'); const button = form.querySelector('[data-add-button]'); const available = option.dataset.available === 'true';
      if (priceNode) { const compare = Number(option.dataset.comparePrice || 0); const price = Number(option.dataset.price || 0); priceNode.innerHTML = `${compare > price ? `<s>${formatMoney(compare)}</s>` : ''}<span>${formatMoney(price)}</span>`; }
      if (button) { button.disabled = !available; const text = button.querySelector('[data-add-text]'); if (text) text.textContent = available ? (strings.addToCart || 'Sepete ekle') : (strings.soldOut || 'Tükendi'); }
      const stock = form.closest('[data-product-section]')?.querySelector('[data-product-stock]'); if (stock) stock.textContent = available ? (strings.inStock || 'Stokta') : (strings.soldOut || 'Tükendi');
      const mediaId = option.dataset.mediaId; if (mediaId) { const section = form.closest('[data-product-section]'); const slider = section?.querySelector('[data-product-slider]'); if (slider?.showMediaById) slider.showMediaById(mediaId); else section?.querySelector(`[data-media-id="${mediaId}"]`)?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'nearest' }); }
      const url = new URL(window.location.href); url.searchParams.set('variant', select.value); window.history.replaceState({}, '', url);
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && document.body.classList.contains('drawer-open')) closeDrawer(); trapFocus(event); });

  const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); }), { threshold: .1 });
  document.querySelectorAll('.reveal').forEach((node) => revealObserver.observe(node));
  if (window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('mousemove', (event) => { const rect = card.getBoundingClientRect(); const x = (event.clientX - rect.left) / rect.width - .5; const y = (event.clientY - rect.top) / rect.height - .5; card.style.transform = `translateY(-4px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg)`; });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
    document.querySelectorAll('[data-parallax-root]').forEach((root) => { const frame = root.querySelector('[data-parallax-card]'); if (!frame) return; root.addEventListener('mousemove', (event) => { const rect = root.getBoundingClientRect(); const x = (event.clientX - rect.left) / rect.width - .5; const y = (event.clientY - rect.top) / rect.height - .5; frame.style.transform = `rotateY(${-2 + x * 4}deg) rotateX(${-y * 4}deg) translate3d(${x * 12}px,${y * 12}px,0)`; }); root.addEventListener('mouseleave', () => { frame.style.transform = ''; }); });
  }


  function initProductSlider(slider) {
    if (!slider || slider.dataset.sliderReady === 'true') return;
    slider.dataset.sliderReady = 'true';

    const track = slider.querySelector('[data-product-slider-track]');
    const viewport = slider.querySelector('[data-product-slider-viewport]');
    const slides = [...slider.querySelectorAll('[data-product-slide]')];
    const thumbs = [...slider.querySelectorAll('[data-product-thumb]')];
    const thumbStrip = slider.querySelector('[data-product-thumbnails]');
    const prev = slider.querySelector('[data-product-slider-prev]');
    const next = slider.querySelector('[data-product-slider-next]');
    const current = slider.querySelector('[data-product-slider-current]');
    if (!track || !viewport || !slides.length) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let pointerStartX = null;
    let pointerStartY = null;

    const pauseInactiveMedia = (active) => {
      slides.forEach((slide, index) => {
        if (index === active) return;
        slide.querySelectorAll('video').forEach((video) => { try { video.pause(); } catch (_) {} });
      });
    };

    const show = (index, options = {}) => {
      const total = slides.length;
      if (!total) return;
      activeIndex = ((Number(index) % total) + total) % total;
      track.style.transform = `translate3d(${-activeIndex * 100}%,0,0)`;
      slides.forEach((slide, i) => {
        const selected = i === activeIndex;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      thumbs.forEach((thumb, i) => {
        const selected = i === activeIndex;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-selected', selected ? 'true' : 'false');
        if (selected && options.scrollThumb !== false && thumbStrip) {
          const desiredLeft = thumb.offsetLeft - ((thumbStrip.clientWidth - thumb.offsetWidth) / 2);
          const maxLeft = Math.max(0, thumbStrip.scrollWidth - thumbStrip.clientWidth);
          const left = Math.max(0, Math.min(desiredLeft, maxLeft));
          thumbStrip.scrollTo({
            left,
            behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'
          });
        }
      });
      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      pauseInactiveMedia(activeIndex);
    };

    slider.showMediaById = (mediaId) => {
      const target = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
      if (target >= 0) show(target);
    };
    slider.showSlide = show;

    prev?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.slideIndex || 0), { scrollThumb: false })));

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(activeIndex + 1); }
    });
    if (!viewport.hasAttribute('tabindex')) viewport.tabIndex = 0;

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    }, { passive: true });
    viewport.addEventListener('pointerup', (event) => {
      if (pointerStartX === null || pointerStartY === null) return;
      const dx = event.clientX - pointerStartX;
      const dy = event.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;
      if (Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy)) return;
      show(activeIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
    viewport.addEventListener('pointercancel', () => { pointerStartX = null; pointerStartY = null; }, { passive: true });

    show(activeIndex, { scrollThumb: false });
  }

  document.querySelectorAll('[data-product-slider]').forEach(initProductSlider);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-product-slider]').forEach(initProductSlider));

  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() { const observer = new IntersectionObserver((entries, io) => { if (!entries[0].isIntersecting) return; io.unobserve(this); fetch(this.dataset.url).then((response) => response.text()).then((text) => { const html = document.createElement('div'); html.innerHTML = text; const recommendations = html.querySelector('product-recommendations'); if (recommendations?.innerHTML.trim()) { this.innerHTML = recommendations.innerHTML; this.querySelectorAll('.reveal').forEach((node) => node.classList.add('is-visible')); } }).catch(() => {}); }, { rootMargin: '0px 0px 400px 0px' }); observer.observe(this); }
  });
})();

/* Ayışığı cinematic scroll controller */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('[data-header]');
  const progress = document.querySelector('[data-scroll-progress]');
  const hero = document.querySelector('[data-hero-scroll]');
  const story = document.querySelector('.ay-story');
  const floats = [...document.querySelectorAll('[data-scroll-float]')];
  let ticking = false;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const viewportProgress = (node) => {
    if (!node) return 0;
    const rect = node.getBoundingClientRect();
    return clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height));
  };

  function updateScrollEffects() {
    ticking = false;
    const y = window.scrollY || document.documentElement.scrollTop;
    if (header) header.classList.toggle('is-scrolled', y > 28);
    if (progress) {
      const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      progress.style.transform = `scaleX(${clamp(y / max)})`;
    }
    if (reduceMotion) return;

    if (hero) {
      const mobileHero = window.innerWidth <= 900 || window.matchMedia('(pointer: coarse)').matches;
      if (mobileHero) {
        // Keep the first-screen copy completely stable on phones. Mobile browser
        // viewport resizing (address bar show/hide) can otherwise make opacity
        // and translate values appear to flicker while scrolling.
        hero.style.setProperty('--hero-copy-y', '0px');
        hero.style.setProperty('--hero-copy-opacity', '1');
        hero.style.setProperty('--hero-visual-y', '0px');
        hero.style.setProperty('--hero-visual-scale', '1');
      } else {
        const rect = hero.getBoundingClientRect();
        const local = clamp(-rect.top / Math.max(rect.height, 1), 0, 1);
        hero.style.setProperty('--hero-copy-y', `${local * 72}px`);
        hero.style.setProperty('--hero-copy-opacity', `${1 - local * .72}`);
        hero.style.setProperty('--hero-visual-y', `${local * -34}px`);
        hero.style.setProperty('--hero-visual-scale', `${1 + local * .055}`);
      }
    }

    if (story) {
      const p = viewportProgress(story) - .5;
      story.style.setProperty('--story-art-y', `${p * -70}px`);
      story.style.setProperty('--story-art-rotate', `${p * 4}deg`);
      story.style.setProperty('--story-copy-y', `${p * 40}px`);
    }

    floats.forEach((node) => {
      const strength = Number(node.dataset.scrollFloat || 0);
      const rect = node.closest('[data-cinematic]')?.getBoundingClientRect();
      if (!rect) return;
      const centerOffset = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      const move = clamp(centerOffset, -1.4, 1.4) * strength * 58;
      node.style.setProperty('--scroll-float-y', `${move}px`);
    });
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrollEffects);
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
  requestTick();

  if (!reduceMotion && window.matchMedia('(pointer:fine)').matches) {
    document.querySelectorAll('.ay-button, .ay-text-link').forEach((node) => {
      node.addEventListener('mousemove', (event) => {
        const rect = node.getBoundingClientRect();
        const x = (event.clientX - rect.left - rect.width / 2) * .08;
        const y = (event.clientY - rect.top - rect.height / 2) * .08;
        node.style.transform = `translate3d(${x}px,${y - 2}px,0)`;
      });
      node.addEventListener('mouseleave', () => { node.style.transform = ''; });
    });
  }
})();

/* Ayışığı v1.4 — luxury entry and soft 3D depth */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const entry = document.querySelector('[data-entry-screen]');
  const shell = document.querySelector('[data-page-shell]');

  if (entry) {
    let seen = false;
    try { seen = sessionStorage.getItem('ayisigi-entry-seen') === '1'; } catch (_) {}

    if (reduceMotion || seen) {
      entry.classList.add('is-skipped');
    } else {
      document.body.classList.add('ay-entry-active');
      const leave = () => {
        if (entry.classList.contains('is-leaving')) return;
        entry.classList.add('is-leaving');
        shell?.classList.add('ay-entry-reveal');
        document.body.classList.remove('ay-entry-active');
        try { sessionStorage.setItem('ayisigi-entry-seen', '1'); } catch (_) {}
        window.setTimeout(() => entry.remove(), 800);
      };
      const start = performance.now();
      const finish = () => window.setTimeout(leave, Math.max(0, 1450 - (performance.now() - start)));
      if (document.readyState === 'complete') finish();
      else window.addEventListener('load', finish, { once: true });
      window.setTimeout(leave, 2300);
    }
  }

  if (reduceMotion || !window.matchMedia('(pointer:fine)').matches) return;

  const cards = [...document.querySelectorAll('[data-depth-card]')];
  cards.forEach((card) => {
    let raf = 0;
    let pointerX = 0;
    let pointerY = 0;

    const paint = () => {
      raf = 0;
      const rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const px = Math.min(1, Math.max(0, (pointerX - rect.left) / rect.width));
      const py = Math.min(1, Math.max(0, (pointerY - rect.top) / rect.height));
      const rx = (0.5 - py) * 5.2;
      const ry = (px - 0.5) * 5.2;
      card.style.setProperty('--depth-rx', `${rx.toFixed(2)}deg`);
      card.style.setProperty('--depth-ry', `${ry.toFixed(2)}deg`);
      card.style.setProperty('--light-x', `${(px * 100).toFixed(1)}%`);
      card.style.setProperty('--light-y', `${(py * 100).toFixed(1)}%`);
    };

    card.addEventListener('pointermove', (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;
      if (!raf) raf = requestAnimationFrame(paint);
    }, { passive: true });

    card.addEventListener('pointerleave', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = 0;
      card.style.setProperty('--depth-rx', '0deg');
      card.style.setProperty('--depth-ry', '0deg');
      card.style.setProperty('--light-x', '50%');
      card.style.setProperty('--light-y', '50%');
    });
  });
})();


// v1.12.2: Collection sorting should not submit blank facet fields.
(() => {
  const bindCollectionSort = (root = document) => {
    root.querySelectorAll('[data-collection-sort]').forEach((select) => {
      if (select.dataset.aySortBound === 'true') return;
      select.dataset.aySortBound = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  };
  bindCollectionSort();
  document.addEventListener('shopify:section:load', (event) => bindCollectionSort(event.target));
})();
